import { createSelector } from '@ngrx/store';

import { selectUnitTrainState, State } from '@ruby/modules/unit-train/store';
import * as fromVesselEvent from '@ruby/modules/unit-train/store/reducers/vessel-event.reducer';

export const selectVesselEventState = createSelector(selectUnitTrainState, (state: State) => state[fromVesselEvent.featureKey]);

